import unreleaseTripMessagesModule from "./unreleaseTripMessagesModule"
import server from "../server"
import arrays from "../../bower_components/front-end-web-commons/app/arrays/arrays"
import tdnSpecification from "../r2/tdnSpecification.json"

unreleaseTripMessagesModule.controller("unreleaseTripMessagesController", [
    "$scope", "$q", "loadingService", "unreleaseTripMessagesService", "unreleaseTripMessageDialog", "messagesModal", "remoteExceptionHandler", ($scope, $q, loadingService, unreleaseTripMessagesService, unreleaseTripMessageDialog, messagesModal, remoteExceptionHandler) => {

        $scope.tdn = tdnSpecification["unrelease-trip-messages"]

        const paginationApi = $q.defer()
        let filterPatch = []

        $scope.filterServiceUrl = server.getRelativeUrl("search.unreleaseTripMessages")

        $scope.messageStatusProcessed = "br.com.neolog.model.integration.domain.UnblockTripMessageStatus.PROCESSED"

        $scope.tableOptions = {
            records: [],
            columns: [{
                cell: {
                    template: "<a name='forceProcess' ng-disabled='!isValidToForceProcessMessage(record)' class='btn btn-xs btn-danger' ng-click='forceProcessMessage(record)'><span class='fa fa-times-circle'></span></a>"
                },
                cellName: "forceProcessButton",
                width: "10px"
            },{
                header: "presentationnode.nodeproperty.unreleasetripmessage.id",
                cell: "{{record.mappedProperties['presentationnode.unreleasetripmessage.id'].value}}",
                cellName: "id"
            },{
                header: "presentationnode.nodeproperty.unreleasetripmessage.tripCodes",
                cell: "{{record.mappedProperties['presentationnode.unreleasetripmessage.tripCodes'].value}}",
                cellName: "tripCodes"
            },{
                header: "presentationnode.nodeproperty.unreleasetripmessage.lastupdate",
                cell: "{{record.mappedProperties['presentationnode.unreleasetripmessage.lastupdate'].value | date:'short'}}",
                cellName: "lastupdate"
            },{
                header: "presentationnode.nodeproperty.unreleasetripmessage.status",
                cell: "{{record.mappedProperties['presentationnode.unreleasetripmessage.status'].value}}",
                cellName: "status"
            },{
                cell: {
                    template: "<a name='inspect' class='btn btn-xs btn-primary' ng-click='inspectMessage(record)'><span class='fa fa-search'></span></a>"
                },
                cellName: "inspectButton",
                width: "10px"
            }],
            pagination: {
                onPaginate: function (firstResult, maxResults) {
                    return loadingService(unreleaseTripMessagesService.filter(filterPatch, firstResult, maxResults)
                        .then(function (response) {
                            response.result = response.result[0].children
                            mapChildrenProperties(response.result)
                            return response
                        }))
                }
            },
            onRegisterPagination: function (api) {
                paginationApi.resolve(api)
            }
        }

        $scope.isValidToForceProcessMessage = function (record) {
            let status = record.mappedProperties["presentationnode.unreleasetripmessage.status"].value
            return $scope.messageStatusProcessed !== status
        }

        $scope.forceProcessMessage = function(record){
            if (!$scope.isValidToForceProcessMessage(record)) {
                return
            }
            messagesModal.cancellable("dialog.proceed?", [{
                keyBundle: "interface.unreleaseTripMessage.forceProcessMessageWarning",
                parameters: [record.id]
            }]).then(function(){
                return loadingService(unreleaseTripMessagesService.forceProcessMessage(record.id))
                    .then(function() {
                    return messagesModal("dialog.success", [{
                        keyBundle: "interface.unreleaseTripMessage.forceProcessMessageSuccess",
                        parameters: []
                    }])
                    .finally(function(){
                        $scope.search( filterPatch )
                    })
                }, remoteExceptionHandler())
            })
        }

        $scope.inspectMessage = (record) => {
            loadingService(unreleaseTripMessagesService.find(record.id))
                .then(unreleaseTripMessageDialog)
                .catch(remoteExceptionHandler())
        }

        function mapChildrenProperties(children) {
            arrays.each(children, function (child) {
                var map = {}
                arrays.each(child.properties, function (property) {
                    map[property.messageKey] = property
                })
                child.mappedProperties = map
            })
        }

        $scope.search = function (patch) {
            filterPatch = patch
            return paginationApi.promise.then((api) => api.seekPage(1))
        }
    }])
